import React from "react";
import { weekdays } from "../../../function/store";

const SelectOptions = ({ openTimeData, setOpenTimeData }) => {
  const handleToggle = (weekday, checked) => {
    setOpenTimeData((prev) => ({
      ...prev,
      byDay: prev.byDay.map((day) =>
        day.weekday === Number(weekday) ? { ...day, isOpen: !checked } : day,
      ),
    }));
  };

  return (
    <div className="cont multiCheckbox">
      {Object.entries(weekdays).map(([key, label]) => {
        const target = openTimeData.byDay.find((d) => d.weekday === Number(key));
        const isChecked = target?.isOpen === false;

        return (
          <label key={key}>
            <input
              type="checkbox"
              value={key}
              checked={isChecked}
              onChange={(e) => handleToggle(key, e.target.checked)}
            />
            <span>{label.replace("요일", "")}</span>
          </label>
        );
      })}
    </div>
  );
};

export default SelectOptions;
